/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SCREEN_WIDTH } from '../stateProvider/StateProvider';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2em;
    border-radius: 2em;
    transition: all 0.35s;
    flex: 1;
    cursor: pointer;

    padding: 0.2em 0.5em;

    &:hover {
        background: ${({ theme }) => (theme.gray + '1a')};
    }
`;
const Option = styled.b`
    transition: all 0.35s; 
    color: ${({ theme, selected }) => selected ? theme.secondary : 'inherit'}
`;
const Highlighter = styled.div`
    position: absolute;
    opacity: 0;
    border: 2px solid ${({ theme }) => theme.secondary};
    border-radius: 2em;
    transition: all 0.35s;
    height: 100%;
`

const ToggleSwitch = ({ ...props }) => {
    const wrapper = useRef();
    const option1 = useRef();
    const option2 = useRef();

    const [opt, setOpt] = useState(null);

    useEffect(() => {
        setTimeout(() => (
            props.options.forEach((e, i) => {
                if (props.value === e.value) {
                    const ref = i === 0 ? option1 : option2;
                    if (!ref.current) return;
                    const dim = ref.current.getBoundingClientRect();
                    const left = i === 0 ? 0 : `calc(${wrapper.current.getBoundingClientRect().width}px - calc(${dim.width + 1}px + 1em))`;
                    setOpt({ left, dim });
                }
            })
        ), 50)
    }, [props.value])

    return (
        <Wrapper ref={wrapper} {...props}>
            {props.options.map((e, i) => (
                <Option
                    ref={i === 0 ? option1 : option2}
                    selected={e.value === props.value}
                    key={e.label + i}
                >
                    {e.label}
                </Option>
            ))}

            {!SCREEN_WIDTH && opt && (
                <Highlighter
                    style={{
                        left: opt.left,
                        width: `calc(${opt.dim.width}px + 1em)`,
                        opacity: 1,
                    }}
                />
            )}
        </Wrapper>
    );
}

export default ToggleSwitch;

